const INITIAL_STATE = {
    categoria: {},
    categorias: [],
    loading: false,
}

export default function Categoria(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'CATEGORIA_LOADING' :
            return { ...state, loading: action.payload };
        case 'CATEGORIAS_FETCHED':
            return { ...state, categorias: action.payload };
        case 'CATEGORIA_FETCHED':
            return { ...state, categoria: action.payload };
        default:
            return state
    }
}